import React from 'react';
import PropTypes from 'prop-types';

import Container from '@material-ui/core/Container';

import { Icon, Translate } from '@hydra/common/components';
import EditorFormRow from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorFormRow';
import EditorInline from '@hydra/routes/pdf-editor/components/EditorFormRow/EditorInline';
import FormToggle from '@hydra/routes/pdf-editor/components/FormToggle';
import FormCheckbox from '@hydra/routes/pdf-editor/components/FormCheckbox';
import FormRadioButtons from '@hydra/routes/pdf-editor/components/FormRadioButtons';
import FormDropdown from '@hydra/routes/pdf-editor/components/FormDropdown';
import InfoLabel from '@hydra/routes/pdf-editor/components/InfoLabel';
import Header from '@hydra/routes/pdf-editor/components/Header';

const rankFilterOptions = [
  { value: '', content: <Translate content='pdf_editor_option_serp_filter_label_all' /> },
  { value: '100', content: <Translate content='pdf_editor_option_serp_filter_label_100' /> },
  { value: '50', content: <Translate content='pdf_editor_option_serp_filter_label_50' /> },
  { value: '10', content: <Translate content='pdf_editor_option_serp_filter_label_10' /> }
];

const orderOptions = [
  { value: 'keyword', content: <Translate content='pdf_editor_option_serp_order_label_keyword' /> },
  { value: 'rank', content: <Translate content='pdf_editor_option_serp_order_label_rank' /> },
  { value: 'volume', content: <Translate content='pdf_editor_option_serp_order_label_volume' /> }
];

export const TabSerp = ({
  template,
  editing,
  saveFormField,
  headerLocked,
  featuresLocked
}) => {
  return (
    <>
      <Header title='pdf_editor_review_tab_serp' hasLockedButton={headerLocked} />
      <Container>
        <EditorFormRow
          label={<Translate content='pdf_editor_enable_serp' />}
          locked={featuresLocked}
        >
          <EditorInline
            Component={FormToggle}
            field='keywordTool.enabled'
            value={template.keywordTool.enabled}
            otherFieldOpen={(editing !== null && editing !== 'keywordTool.enabled')}
            locked={featuresLocked}
            saveFormField={({ value }) => saveFormField({
              field: 'keywordTool',
              value: {
                ...template.keywordTool,
                enabled: value
              }
            })}
          />
        </EditorFormRow>
        {
          template.keywordTool.enabled || headerLocked
            ? (
              <>
                <EditorFormRow
                  label={<Translate content='pdf_editor_option_serp_display_graph' />}
                  help={<Translate content='pdf_editor_option_serp_help_display_graph' />}
                  locked={featuresLocked}
                >
                  <EditorInline
                    Component={FormToggle}
                    field='keywordTool.displayChart'
                    value={template.keywordTool.displayChart}
                    otherFieldOpen={(editing !== null && editing !== 'keywordTool.displayChart')}
                    locked={featuresLocked}
                    saveFormField={({ value }) => saveFormField({
                      field: 'keywordTool',
                      value: {
                        ...template.keywordTool,
                        displayChart: value
                      }
                    })}
                  />
                </EditorFormRow>
                <EditorFormRow
                  label={<Translate content='pdf_editor_option_serp_table_columns' />}
                  help={<Translate content='pdf_editor_option_serp_help_table_columns' />}
                  locked={featuresLocked}
                >
                  <EditorInline
                    Component={FormCheckbox}
                    field='keywordTool.tableColumns.location'
                    label={<Translate content='serp_front_location' />}
                    value={template.keywordTool.tableColumns.location}
                    otherFieldOpen={(editing !== null && editing !== 'keywordTool.tableColumns.location')}
                    locked={featuresLocked}
                    saveFormField={({ value }) => saveFormField({
                      field: 'keywordTool',
                      value: {
                        ...template.keywordTool,
                        tableColumns: {
                          ...template.keywordTool.tableColumns,
                          location: value
                        }
                      }
                    })}
                  />
                  <EditorInline
                    Component={FormCheckbox}
                    field='keywordTool.tableColumns.volume'
                    label={<Translate content='serp_front_volume' />}
                    value={template.keywordTool.tableColumns.volume}
                    otherFieldOpen={(editing !== null && editing !== 'keywordTool.tableColumns.volume')}
                    locked={featuresLocked}
                    saveFormField={({ value }) => saveFormField({
                      field: 'keywordTool',
                      value: {
                        ...template.keywordTool,
                        tableColumns: {
                          ...template.keywordTool.tableColumns,
                          volume: value
                        }
                      }
                    })}
                  />
                  <EditorInline
                    Component={FormCheckbox}
                    field='keywordTool.tableColumns.competitors'
                    label={<Translate content='competitors_label' />}
                    value={template.keywordTool.tableColumns.competitors}
                    otherFieldOpen={(editing !== null && editing !== 'keywordTool.tableColumns.competitors')}
                    locked={featuresLocked}
                    saveFormField={({ value }) => saveFormField({
                      field: 'keywordTool',
                      value: {
                        ...template.keywordTool,
                        tableColumns: {
                          ...template.keywordTool.tableColumns,
                          competitors: value
                        }
                      }
                    })}
                  />
                </EditorFormRow>
                <EditorFormRow
                  label={<Translate content='pdf_editor_option_serp_order' />}
                  help={<Translate content='pdf_editor_option_serp_help_order' />}
                  locked={featuresLocked}
                >
                  <EditorInline
                    Component={FormDropdown}
                    items={orderOptions}
                    field='keywordTool.order'
                    value={template.keywordTool.order}
                    otherFieldOpen={(editing !== null && editing !== 'keywordTool.order')}
                    locked={featuresLocked}
                    saveFormField={({ value }) => saveFormField({
                      field: 'keywordTool',
                      value: {
                        ...template.keywordTool,
                        order: value
                      }
                    })}
                  />
                </EditorFormRow>
                <EditorFormRow
                  label={<Translate content='pdf_editor_option_serp_filter' />}
                  help={<Translate content='pdf_editor_option_serp_help_filter' />}
                  locked={featuresLocked}
                >
                  <EditorInline
                    Component={FormRadioButtons}
                    items={rankFilterOptions}
                    field='keywordTool.rankFilter'
                    value={template.keywordTool.rankFilter}
                    otherFieldOpen={(editing !== null && editing !== 'keywordTool.rankFilter')}
                    locked={featuresLocked}
                    saveFormField={({ value }) => saveFormField({
                      field: 'keywordTool',
                      value: {
                        ...template.keywordTool,
                        rankFilter: value
                      }
                    })}
                  />
                </EditorFormRow>
              </>
              )
            : (
              <EditorFormRow infoLabel>
                <InfoLabel style='default'>
                  <Icon type='information' style={{ marginRight: 8 }} />
                  <Translate content='pdf_editor_serp_info' />
                </InfoLabel>
              </EditorFormRow>
              )
        }
      </Container>
    </>
  );
};

TabSerp.propTypes = {
  template: PropTypes.shape({
    name: PropTypes.string
  })
};

export default React.memo(TabSerp);
